module.exports = __webpack_public_path__ + "assets/images/vcr_hotel-01.bc5bdca4193b66d8c20cd9b2ad8770a9.svg";